import { FC } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { SessionData } from '../../services/Measurement';
import { numberToMinutes } from '../../utils/numberToMinutes';

const Cell = styled.td(({ theme }) => {
  const { color } = theme;

  return `
    text-align: center;
    border: 1px solid ${color.grayscale[600]};
    padding: 10px;
  `;
});

const NotesCell = styled.td(({ theme }) => {
  const { color } = theme;

  return `
    text-align: center;
    border: 1px solid ${color.grayscale[600]};
    padding: 10px;
    max-width: 250px;
  `;
});

export interface IMeasurementRow {
  session: SessionData;
  isTimeBased: boolean;
}

const formatValue = (value: number | null, isToApplyPercentage: boolean, isTimeBased = false): string => {
  if (!value || value === null) {
    return 'N/A';
  }

  if (isTimeBased) {
    return numberToMinutes(value);
  }

  if (isToApplyPercentage) {
    return `${value}%`;
  }

  return `${value}`;
};

const MeasurementRow: FC<IMeasurementRow> = ({ session, isTimeBased }) => {
  const { id, result_date, cognitive_assistance, physical_assistance, standing_tolerance, resistance, value, notes } =
    session;

  return (
    <tr>
      <Cell>{id}</Cell>
      <Cell>{moment(result_date).format('L')}</Cell>
      <Cell>{formatValue(cognitive_assistance, true)}</Cell>
      <Cell>{formatValue(physical_assistance, true)}</Cell>
      <Cell>{formatValue(resistance, true)}</Cell>
      <Cell>{formatValue(standing_tolerance, true)}</Cell>
      <Cell>{formatValue(value, false, isTimeBased)}</Cell>
      <NotesCell>{notes}</NotesCell>
    </tr>
  );
};

export default MeasurementRow;
